import type { CountryItem } from './types';

export const formatPhoneNumber = (phone: string, items: CountryItem[]) => {
  const value = phone
    .replace(/[^\d-+]/g, '') // remove everything except digits and +
    .replace(/(?!^)\+/g, ''); // allow only first +

  const validItem = items.find((item) => value.startsWith(item.value));
  if (validItem) {
    const suffix = value
      .substring(validItem.value.length)
      .replace(/([0-9+-]{3})(?=\d)/g, '$1 ');

    if (suffix) {
      return validItem.value + ' ' + suffix;
    }
  }

  return value.replace(/([0-9+-]{3})(?=\d)/g, '$1 ');
};
